// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__11R9T","name":"ConsentHeader_name__1wC7-","birthday":"ConsentHeader_birthday__eusHq","skeleton":"ConsentHeader_skeleton__36VNz"};